(() => {  
    'use strict';

    angular
        .module('cog.shared')        
        .service('lineFormater', lineFormater);

    /* @ngInject */
    function lineFormater($http, $state, $q, $window) {

        function _getWagerType(id: string) {
            var wt="", tmp;
            tmp=id.split('_')[0];
            if (tmp=='0' || tmp=='1')
                wt='S';
            else if (tmp=='2' || tmp=='3' || tmp=='10')
                wt='M';                
            else if (tmp=='4' || tmp=='6' || tmp=='7')
                wt='TO';
            else if (tmp=='5' || tmp=='8' || tmp=='9')
                wt='TU';                    
            return wt;
        }

        function getGameId(id: string) {
            return parseInt(id.split('_')[1]);
        }
        
        function getOdds(id){            
            return parseInt(id.split('_')[3]);
        }
        
        function getPoints(id){
            return parseFloat(id.split('_')[2]);
        }

        function getBuyPoints(id) {
            return parseFloat(id.split('_')[4]);
        }
        
        function _formatOdds(odds:number,wt){                                   
            return ((odds > 0)?"+":"") + odds.toString();
        } 
        
        function _formatPoints(points:number,wt, raw){                
            var format = "";
            if (wt=="M") return "";
            if (points > 0 && wt == "S") format += "+";

            if (wt == "TO") {
                format +="o";   
            }else if (wt == "TU") {
                format +="u";
            }       

            if (points == 0) format += "pk";
            else if (points % 1 != 0) {
                var arr = points.toString().split('.');
                var frac = arr[1];
                var whole = parseInt(arr[0]);

                if (whole != 0 && whole != -0)
                    format += whole;
                else
                    if (points < 0) format += "-";

                if (frac == "5") {
                    if(raw)
                        format += "½";
                    else
                        format += "&frac12;";
                }
                else if (frac == "25" || frac == "75") format = (points < 0) ? 
                    _formatPoints(points + 0.25,wt, raw) + " & " + _formatPoints(points - 0.25,wt, raw) : 
                    _formatPoints(points - 0.25,wt, raw) + " & " + _formatPoints(points + 0.25,wt, raw);
                else format += "." + frac;
            }
            else
                format += points;
            return format;                        
        }       

        function IsVisitor(id: string) {
            var tmp, isVisitor:boolean = false;
            tmp = id.split('_')[0];
            if (tmp == '0' || tmp == '2' || tmp == '4' || tmp == '6' || tmp == '8')
                 isVisitor = true;
            return isVisitor;
        }

        function IsTotal(id: string) {
            var tmp, isTotal: boolean = false;
            tmp = id.split('_')[0];
            if (tmp == '4' || tmp == '5')
                    isTotal = true;
            return isTotal;
        }

        function IsTeamTotal(id: string) {
            var tmp, isTeamTotal: boolean = false;
            tmp = id.split('_')[0];
            if (tmp == '6' || tmp == '7' || tmp == '8' || tmp == '9')
                isTeamTotal = true;
            return isTeamTotal;
        }

        function IsContest(id: string) {
            var tmp, isContest: boolean = false;
            tmp = id.split('_')[5];
            if (parseInt(tmp) > 0)
                isContest = true;
            return isContest;
        }

        function getPeriod(id) {
            return parseInt(id.split('_')[6]);
        }

        var service: ILineFormater = {
            format:  (id)=>{                      
                var reformat:FormatedLine = {Odds: "", Points:""};
                var wt = _getWagerType(id);
                reformat.Odds = _formatOdds(getOdds(id), wt);
                if (wt != "M")
                    reformat.Odds = "(" + reformat.Odds + ")";
                reformat.Points = _formatPoints(getPoints(id), wt, false);
                return reformat;         
            },            
            data: (id) => {
                var reformat: FormatedLineData = { Type: "", GameId: 0, Points: 0, Odds: 0, IsVisitor: false, IsTotal: false, IsTeamTotal: false, Period: 0, BuyPoints: 0, IsContest: false };
                var wt = _getWagerType(id);
                reformat.Type = wt;
                reformat.GameId = getGameId(id);
                reformat.Points = getPoints(id);
                reformat.Odds = getOdds(id);
                reformat.IsVisitor = IsVisitor(id);
                reformat.IsTotal = IsTotal(id);
                reformat.IsTeamTotal = IsTeamTotal(id);
                reformat.Period = getPeriod(id);
                reformat.BuyPoints = getBuyPoints(id);
                reformat.IsContest = IsContest(id);
                return reformat;
            }
        };
        return service;
        
                
    }
})();